/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ListEnrolledCoursesParams,
  PaginatedEnrolledCourses,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary List of Enrolled Courses
 */
export const listEnrolledCourses = (
    params?: MaybeRefOrGetter<ListEnrolledCoursesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedEnrolledCourses>(
      {url: `/enrolled_courses`, method: 'GET',
        params, signal
    },
      );
    }




export const getListEnrolledCoursesQueryKey = (params?: MaybeRefOrGetter<ListEnrolledCoursesParams>,) => {
    return [
    'enrolled_courses', ...(params ? [params] : [])
    ] as const;
    }


export const getListEnrolledCoursesQueryOptions = <TData = Awaited<ReturnType<typeof listEnrolledCourses>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<ListEnrolledCoursesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEnrolledCourses>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListEnrolledCoursesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEnrolledCourses>>> = ({ signal }) => listEnrolledCourses(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEnrolledCourses>>, TError, TData>
}

export type ListEnrolledCoursesQueryResult = NonNullable<Awaited<ReturnType<typeof listEnrolledCourses>>>
export type ListEnrolledCoursesQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List of Enrolled Courses
 */

export function useListEnrolledCourses<TData = Awaited<ReturnType<typeof listEnrolledCourses>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<ListEnrolledCoursesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listEnrolledCourses>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListEnrolledCoursesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






